/**
 * The Urdu catalogue. **Every string here is pending review by a native Urdu reader** (`TY-01a`,
 * `RTL-02`, `SC-04`): they were written by the implementer, not by a translator, and the PRD's own
 * rule is that "every release is reviewed in Urdu with real strings before shipping".
 *
 * `Partial` on purpose. A key with no entry here renders its English text, which is a visible gap
 * a reviewer can see. A guessed translation on a till is a wrong instruction that looks right, and
 * a shopkeeper cannot tell it from a correct one. The keys left out are named in
 * `test/catalogue.test.ts`, so the list cannot drift silently.
 *
 * Digits: Western, in the strings and in the placeholders (`D-03`, `TY-03`). The catalogue test
 * refuses Arabic-Indic and Extended Arabic-Indic digits.
 */
export const ur = {
    'shell.branch': 'برانچ',
    'shell.drawerOpen': 'کیش دراز کھلا ہے',
    'shell.drawerClosed': 'کیش دراز بند ہے',
    'shell.signOut': 'سائن آؤٹ',
    'shell.waiting': 'انتظار میں',
    'nav.queue': 'کام کی فہرست',
    'nav.customers': 'گاہک',
    'nav.newOrder': 'نیا آرڈر',
    'nav.orders': 'آرڈرز',
    'nav.cash': 'کیش دراز',
    'action.job.sent': 'لیب کو بھیجا ہوا نشان زد کریں',
    'action.job.chasing': 'لیب سے پیروی شروع کریں',
    'action.job.inProduction': 'تیاری میں نشان زد کریں',
    'action.job.shipped': 'لیب سے روانہ نشان زد کریں',
    'action.job.received': 'برانچ میں موصول نشان زد کریں',
    'action.job.qc': 'معیار کی جانچ شروع کریں',
    'action.job.ready': 'وصولی کے لیے تیار نشان زد کریں',
    'action.job.collected': 'جاب وصول کریں',
    'action.job.onHold': 'روک دیں',
    'action.job.cancelled': 'جاب منسوخ کریں',
    'action.job.resumeTo': 'دوبارہ شروع کریں، واپس {status} پر',
    'jobDetail.writeLabel': '{action} (جاب {number})',
    'status.rxType.distance': 'دور کی نظر',
    'status.rxType.near': 'قریب کی نظر',
    'status.rxType.bifocal': 'دو فوکل',
    'status.rxType.progressive': 'پروگریسو',
    'status.rxType.safety': 'حفاظتی',
    'status.rxType.contactLens': 'کانٹیکٹ لینس',
    'status.rx.draft': 'ڈرافٹ',
    'status.rx.active': 'فعال',
    'status.rx.expired': 'مدت ختم',
    'status.order.draft': 'ڈرافٹ',
    'status.order.confirmed': 'تصدیق شدہ',
    'status.order.partiallyPaid': 'جزوی ادائیگی',
    'status.order.paid': 'ادا شدہ',
    'status.order.closed': 'بند',
    'status.order.expired': 'مدت ختم',
    'status.order.cancelled': 'منسوخ',
    'status.order.onHold': 'روکا ہوا',
    'status.job.draft': 'ڈرافٹ',
    'status.job.sent': 'لیب کو بھیجا گیا',
    'status.job.chasing': 'لیب سے پیروی',
    'status.job.inProduction': 'تیاری میں',
    'status.job.shipped': 'لیب سے روانہ',
    'status.job.received': 'برانچ میں موصول',
    'status.job.qc': 'معیار کی جانچ',
    'status.job.ready': 'وصولی کے لیے تیار',
    'status.job.collected': 'وصول کر لیا گیا',
    'status.job.onHold': 'روکا ہوا',
    'status.job.cancelled': 'منسوخ',
    'status.cashSession.open': 'کھلا',
    'status.cashSession.counting': 'گنتی جاری',
    'status.cashSession.closed': 'بند',
    'queue.online': 'آن لائن',
    'queue.offline': 'آف لائن',
    'queue.synced': '{connection}، سب کچھ محفوظ ہو گیا',
    'queue.busy': '{connection}، {detail}',
    'queue.waitingToSync': {
        one: '{count} محفوظ ہونے کے انتظار میں',
        other: '{count} محفوظ ہونے کے انتظار میں',
    },
    'queue.needAttention': {
        one: '{count} پر توجہ درکار ہے',
        other: '{count} پر توجہ درکار ہے',
    },
    'queue.statusLine': '{queueState}۔ {writeState}',
    'queue.write.saved': '{subject} محفوظ ہو گیا۔',
    'queue.write.blocked': '{subject} محفوظ نہیں ہوا: {reason}۔ اس پر توجہ درکار ہے۔',
    'queue.write.pending': '{subject} اسی ڈیوائس پر ہے اور سرور تک پہنچنے پر محفوظ ہو جائے گا۔',
    'queue.write.refusedNoReason': 'سرور نے قبول نہیں کیا',
    'queue.subject.prescription': 'نظر کا نسخہ',
    'queue.subject.payment': 'ادائیگی',
    'queue.subject.order': 'آرڈر',
    'queue.subject.confirmation': 'تصدیق',
    'queue.subject.openingFloat': 'ابتدائی رقم',
    'queue.subject.count': 'گنتی',
    'queue.subject.payOut': 'رقم باہر',
    'queue.subject.payIn': 'رقم اندر',
    'jobDetail.write.saved': '{label}: محفوظ ہو گیا۔',
    'jobDetail.write.blocked': '{label}: یہ محفوظ نہیں ہوا، {reason}۔ اس پر توجہ درکار ہے۔',
    'jobDetail.write.pending': '{label}: اسی ڈیوائس پر ہے، سرور تک پہنچنے پر محفوظ ہو جائے گا۔',
    'signIn.heading': 'سائن ان',
    'signIn.email': 'ای میل ایڈریس',
    'signIn.password': 'پاس ورڈ',
    'signIn.submit': 'سائن ان',
    'signIn.busy': 'سائن ان ہو رہا ہے',
    'signIn.unreachable': 'ہم ابھی آپ کے اکاؤنٹ تک نہیں پہنچ پا رہے۔ یہ آپ کے پاس ورڈ کا مسئلہ نہیں ہے، کچھ دیر بعد دوبارہ کوشش کریں۔',
    'customerSearch.heading': 'کون سا گاہک؟',
    'customerSearch.label': 'نام یا فون نمبر',
    'customerSearch.why.name': 'نام',
    'customerSearch.why.sound': 'ملتی جلتی آواز',
    'customerSearch.why.phone': 'فون',
    'customerSearch.hint.short': 'کم از کم دو حروف لکھیں، یا فون نمبر۔',
    'customerSearch.hint.searching': 'تلاش جاری ہے',
    'customerSearch.hint.none': 'کوئی گاہک نہیں ملا۔ ہجے دیکھیں، یا فون نمبر آزمائیں۔',
    'customerSearch.hint.found': {
        one: '{count} ملا۔ چننے کے لیے اوپر نیچے کی کیز، منتخب کرنے کے لیے Enter دبائیں۔',
        other: '{count} ملے۔ چننے کے لیے اوپر نیچے کی کیز، منتخب کرنے کے لیے Enter دبائیں۔',
    },
    'blocked.heading': {
        one: '{count} چیز محفوظ نہیں ہوئی اور اس کے بعد کی ہر چیز رکی ہوئی ہے',
        other: '{count} چیزیں محفوظ نہیں ہوئیں اور ان کے بعد کی ہر چیز رکی ہوئی ہے',
    },
    'blocked.noReason': 'سرور نے اسے قبول نہیں کیا اور کوئی وجہ نہیں بتائی۔',
    'blocked.retry': 'دوبارہ کوشش کریں',
    'blocked.discard': 'رد کریں',
    'blocked.confirmDiscard': 'کیا "{label}" رد کریں؟ یہ کہیں محفوظ نہیں ہوا اور واپس نہیں لایا جا سکتا۔',
    'app.noBranch': 'آپ کسی برانچ کے ساتھ منسلک نہیں ہیں، اس لیے ابھی یہاں کچھ نہیں کر سکتے۔ مالک سے کہیں کہ آپ کو برانچ تک رسائی دیں۔',
    'app.back': 'واپس',
    'app.backToSearch': 'تلاش پر واپس',
    'app.backToOrders': 'آرڈرز پر واپس',
    'app.capturePrescription': 'نظر کا نسخہ درج کریں',
    'app.takePayment': 'ادائیگی لیں',
    // Plain words with one settled Urdu rendering. "Store credit" and "Panel" are left out: both
    // are trade terms (`TY-01a`).
    'common.open': 'کھولیں',
    'common.total': 'کل',
    'common.outstanding': 'باقی',
    'common.reason': 'وجہ',
    'common.quantity': 'مقدار',
    'common.amount': 'رقم',
    'common.notRecorded': 'درج نہیں',
    'tender.cash': 'نقد',
    'tender.card': 'کارڈ',
    'tender.bankTransfer': 'بینک ٹرانسفر',
    'tender.wallet': 'موبائل والٹ',
    'tender.giftCard': 'گفٹ کارڈ',
    'tender.voucher': 'واؤچر',
    'tender.cod': 'کیش آن ڈیلیوری',
    'jobDetail.qc.passed': 'کامیاب',
    'jobDetail.qc.failed': 'ناکام',
    'orderList.heading': 'آرڈرز اور جابز',
    'rxCapture.save': 'نسخہ محفوظ کریں',
    'mira.close': 'بند کریں',
    'mira.field.accept': 'قبول کریں',
    'mira.field.edit': 'ترمیم کریں',
    'mira.field.reject': 'مسترد کریں',
};
//# sourceMappingURL=ur.js.map